<template>
  <div>
    <div class="col-8" v-if="EvaluationForm.initialized">
      <h2 class="card-title" v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN">Evaluation Status:
        <el-select class="filter-select mr-2 mb-2" v-model="EvaluationForm.evaluation.status" placeholder="Choose evaluation status" @change="changeEvaluationStatus">
          <el-option v-for="item in evaluationStatuses" :key="item" :label="item.toUpperCase()" :value="item"/>
        </el-select>
      </h2>
    </div>
    <div v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN" class="text-right mb-3">
      <base-button @click="deleteEvaluation(applicationId, evaluationTypeNickname)" v-if="loggedUser.role === UserRoles.ADMIN" type="warning" size="lg" class="btn-fill text-right mr-3">
        Delete Evaluation
      </base-button>
      <base-button @click="exportEvaluation(applicationId, evaluationTypeNickname,evaluationType.fp)" type="primary" size="lg" class="btn-fill text-right">
        Export Evaluation
      </base-button>
    </div>
    <component-loader
      :key="$i18n.locale"
      v-if="componentInitialized"
      :component-name="componentName"
      :default-component-name="defaultComponentName"
      id="applicationComponent"
    >
    </component-loader>
  </div>
</template>
<script>
  import {EventBus} from '@/event-bus.js';
  import {
    EvaluationService,
    UserRoles,
    FileUploadService,
    EvaluationForm
  } from '@/services';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab, ExportApplication} from 'src/components';
  import ComponentLoader from './ComponentLoader';
  import {Select, Option} from 'element-ui';

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ComponentLoader,
      ExportApplication
    },
    data() {
      return {
        EvaluationForm,
        UserRoles,
        application: {},
        loggedUser: {},
        applicationId: parseInt(this.$route.params.applicationId),
        evaluationUserId: parseInt(this.$route.params.evaluationUserId),
        evaluationType: {},
        evaluationTypeNickname: this.$route.params.evaluationTypeNickname,
        evaluationId: undefined,

        evaluationStatuses: [
          'draft',
          'submitted',
        ],

        componentInitialized: false,
        componentName: 'Dynamic',
        defaultComponentName: 'Default',
        data: {}
      }
    },
    provide() {
      return {
        validateEvaluation: this.validateEvaluation
      };
    },
    methods: {
      getEvaluationType(nickname, applicationId) {
        let vm = this;

        return EvaluationService.getEvaluationTypeNickname(nickname, applicationId).then(function (response) {
          let evaluationType = response.data;

          vm.evaluationType = evaluationType;
          vm.componentName = evaluationType.component_name;
        })
      },
      getApplication() {
        let vm = this;

        EvaluationForm.init();

        return EvaluationService.getApplicationEvaluation({
          application_id: vm.applicationId,
          evaluation_type_nickname: vm.evaluationTypeNickname,
          evaluation_user_id: vm.evaluationUserId
        }).then(function (response) {
          let evaluation = response.data.evaluation;
          let application = response.data.application;

          vm.application = application;
          EvaluationForm.evaluation = evaluation;
          EvaluationForm.application = application;
          EvaluationForm.initialized = true;

          let alwaysEditable = ['final_result'];

          let hasPermission = (vm.evaluationType.roles.indexOf(vm.loggedUser['role']) !== -1);
          EvaluationForm.isEditable = (hasPermission && (!evaluation.id || evaluation.status === 'draft' || alwaysEditable.indexOf(vm.evaluationTypeNickname) !== -1));

          if (vm.evaluationTypeNickname === 'technical' && evaluation.id && evaluation.user_id !== vm.loggedUser['id']) {
            EvaluationForm.isEditable = false;
          }

          if ((vm.evaluationTypeNickname === 'final_result' || vm.evaluationTypeNickname === 'fp_final_decision') && evaluation.id && evaluation.status === 'submitted' && [UserRoles.ADMIN].indexOf(vm.loggedUser['role']) === -1) {
            EvaluationForm.isEditable = false;
          }

          if (!evaluation.data) {
            evaluation.model = {};
          }
          EvaluationForm.model = evaluation.model;

          if (!evaluation.files) {
            evaluation.files = {};
          }
          EvaluationForm.files = evaluation.files;

          // setting filesize limit to state
          EvaluationForm.fileSizeLimit = response.data.upload_max_filesize;

        }).catch(function (error) {
          alert(error.data.message);
          vm.$router.push('/applications');
        });
      },

      async saveProgress(status) {
        let vm = this;
        let model = EvaluationForm.model;
        let totalScore = EvaluationForm.totalScore ? EvaluationForm.totalScore : null;
        let loader = this.$loading.show();
        let isSuccess = false;

        //Concept evaluation decision status update
        if(vm.evaluationType.evaluation_type_id == 64 && status == 'submitted'){
            vm.conceptDecisionSelect();
        }
        await EvaluationService.submitEvaluation({
          application_id: vm.applicationId,
          evaluation_type_id: vm.evaluationType.evaluation_type_id,
          evaluation_user_id: vm.evaluationUserId,
          model: model,
          status: status,
          total_score: totalScore
        }).then((response) => {
          vm.evaluationId = response.data.id;
          isSuccess = true;

        }).catch((error) => {
          if (error.data.message) {
            alert(error.data.message);
          }
        });

        loader.hide();

        if (!isSuccess) {
          this.$router.push('/applications');
          return false;
        }

        await this.uploadFiles();

        if (status === 'submitted') {
          await this.showNotification('complete-progress');
        } else {
          await this.showNotification('save-progress');
        }

        if (status !== undefined && status === 'submitted') {
          this.$router.push('/applications');
        } else {
          vm.getApplication();
        }
      },

      async validateEvaluation() {
        let vm = this;
        let evaluation_id = EvaluationForm.evaluation.id;
        if (EvaluationForm.evaluation.status !== 'submitted') {
          alert('Evaluation is not submitted, still on draft.');
          return;
        }

        let loader = vm.$loading.show();
        await EvaluationService.validateEvaluation(evaluation_id).then(function (response) {
          vm.getApplication();

        }).catch(function (error) {
          alert(error.message);
        })

        loader.hide();
      },

      changeEvaluationStatus()
      {
        let vm = this;
      debugger;
        if (confirm('Are you sure you want to change evaluation status?'))
        {
          EvaluationService.changeStatus({
            application_id: vm.applicationId,
            evaluation_type_id: vm.evaluationType.evaluation_type_id,
            evaluation_user_id: vm.evaluationUserId,
            status: EvaluationForm.evaluation.status,
          });
        }
      },

      //Concept Decision select api
      conceptDecisionSelect()
      {
        let vm = this;
        EvaluationService.conceptEvaluationStatus({
            application_id: vm.applicationId,
            status: EvaluationForm.model.evaluation_status,
          });
      },
      deleteEvaluation()
      {
        let vm = this;

        if (confirm('Are you sure you want to remove current evaluation?'))
        {
          EvaluationService.deleteEvaluation({
            evaluation_id: EvaluationForm.evaluation.evaluation_id,
            application_id: vm.applicationId,
            evaluation_type_id: vm.evaluationType.evaluation_type_id,
            evaluation_user_id: vm.evaluationUserId,
            status: EvaluationForm.evaluation.status,
          }).then(function ()
          {
            vm.$router.push('/applications');
          });
        }
      },

      async preCompleteValidation() {
        let vm = this;
        let valid = true;
        let evaluation_types_to_validate = ['final_result'];

        if(evaluation_types_to_validate.indexOf(vm.evaluationTypeNickname) !== -1) {
          if(!EvaluationForm.model.final_status || !EvaluationForm.model.final_result_score) {
            valid = false;
          }

        } else {
          valid = true;
        }

        return valid;
      },

      async onBeforeCompleteProgress() {
        let vm = this;
        let valid = await vm.preCompleteValidation();
        if (!valid) {
          vm.showPreSubmitValidationNotification();
          return;
        }

        var submitConfirmation = await vm.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {
          vm.saveProgress('submitted');
        }
      },

      showPreSubmitValidationNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: 'You need to complete all fields before submitting.',
          type: 'warning',
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'OK'
        })
      },

      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__pre_submit_evaluation').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: this.$t('general.notification__submit_evaluation'),
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: this.$t('general.notification__cancel_submit_evaluation'),
        })
      },

      async showNotification(type) {
        if (type === 'save-progress') {
          return await swal({
            title: this.$t('general.notification__success'),
            html: this.$t('general.notification__ev_progress_saved').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        } else if (type === 'complete-progress') {
          return await swal({
            title: this.$t('general.notification__success'),
            html: this.$t('general.notification__ev_progress_submitted').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        }
      },

      async uploadFiles() {
        let files = EvaluationForm.files;
        let promises = [];

        for (var section in files) {
          if (EvaluationForm.files.hasOwnProperty(section)) {

            for (var subSection in files[section]) {
              if (files[section].hasOwnProperty(subSection)) {

                let fileToUpload = files[section][subSection];
                if (fileToUpload instanceof File) {

                  let formData = new FormData();
                  formData.append('file', fileToUpload);
                  formData.append('section', fileToUpload.section);
                  formData.append('$section', section);
                  formData.append('$subSection', subSection);
                  if (fileToUpload.id) {
                    formData.append('id', fileToUpload.id);
                  }

                  let promise = FileUploadService.uploadEvaluationFile({
                    evaluationId: this.evaluationId,
                    formData: formData
                  }).then(function (response) {
                    let fdSection = formData.get('$section');
                    let fdSubSection = formData.get('$subSection');

                    files[fdSection][fdSubSection] = {
                      id: response.data.id,
                      name: response.data.filename,
                      download: response.data.download
                    };

                  }).catch(function (error) {
                    console.log('err', error);
                  })

                  promises.push(promise);
                }
              }
            }
          }
        }

        return await Promise.all(promises);
      },

      exportEvaluation(application_id, name, fp)
      {
        let vm = this;

        if (!EvaluationForm.evaluation.id)
        {
          alert('Currently there\'s no evaluation for this application. You need to save your evaluation before exporting it.');
          return ;
        }

        let loader = vm.$loading.show();
        if(fp == 0){
            EvaluationService.exportConceptEvaluation({
              application_id: application_id,
              name: name,
            }).then((response) => {
              if (response.data && response.data.success)
              {
                window.open(response.data.url, '_blank');
              }

              loader.hide();
            });

        }
        else{
          EvaluationService.exportEvaluation({
            application_id: application_id,
            name: name,
          }).then((response) => {
            if (response.data && response.data.success)
            {
              window.open(response.data.url, '_blank');
            }

            loader.hide();
          });
        }
      },
    },

    async mounted() {
      let vm = this;
      let loader = vm.$loading.show();

      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
      await vm.getEvaluationType(vm.evaluationTypeNickname, vm.applicationId);
      await vm.getApplication();

      vm.componentInitialized = true;

      loader.hide();

      EventBus.$off('evaluation-save-progress');
      EventBus.$off('evaluation-complete-progress');

      EventBus.$off('evaluation-save-progress');
      EventBus.$on('evaluation-save-progress', data => {
        vm.saveProgress();
      });

      EventBus.$off('evaluation-complete-progress');
      EventBus.$on('evaluation-complete-progress', data => {
        vm.onBeforeCompleteProgress();
      });

      // force scroll reload
      document.documentElement.style.overflow = 'auto'; // firefox chrome
      document.body.scroll = "yes"; // ie only
    },
  };
</script>
